import { OccConfig } from '@spartacus/core';

export const reportsOccContentConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        pricingStatus: 'users/${userId}/reports/pricing-status',
        purchaseSummary: 'users/${userId}/reports/purchase-summary',
        purchaseSummaryDetails: 'users/${userId}/reports/purchase-summary/details',
        creditSummary: 'users/${userId}/reports/credit-summary',
        paymentHistory: 'users/${userId}/reports/payment-history',
        paymentHistoryDetails: 'users/${userId}/reports/payment-history/details',
      },
    } as any,
  },
};
